export function imgixUrl(url, { w, q = 40 } = {}) {
  if (!url) return ''
  const clean = String(url).split('?')[0]
  const params = new URLSearchParams({
    auto: 'compress',
    fm: 'webp',
    q: String(q),
  })
  if (w) {
    params.set('w', String(w))
    params.set('fit', 'max')
  }
  return `${clean}?${params.toString()}`
}

export function imgixSrcset(url, widths = [800, 900, 1400], q = 90) {
  if (!url) return ''
  return widths.map((width) => `${imgixUrl(url, { w: width, q })} ${width}w`).join(', ')
}
